import { Box } from '@ff-it/ui';
import { TitleContainer } from 'components/TitleContainer';
import { ProductTitle } from 'modules/supplier/products';
import { oddRow } from 'styles/style.css';
import { parseBig, fmt } from 'utilities';
import type { LinkerContext } from '../types';
import { amountColumn, numberCell, popoverText, popoverTextBold, popoverTitle, tableCell } from './style.css';

interface LinkableRowsPopoverProps {
  linkableIds: number[];
  linkerContext: LinkerContext;
}

/**
 * This shows the list of linkable campaign rows that were grouped under the same imported block code.
 */
export function LinkableRowsPopover({ linkableIds, linkerContext }: LinkableRowsPopoverProps) {
  return (
    <Box p="1">
      <div className={popoverTitle}>Campaign rows</div>
      <table>
        <colgroup>
          <col />
          <col />
          <col className={amountColumn} />
        </colgroup>
        <tbody>
          {linkableIds.map((id, idx) => {
            const linkable = linkerContext.linkable.find((l) => Number(l.id) === id);
            if (!linkable) return null;
            const product = linkerContext.entities.product[linkable.product_id];
            const provider = linkerContext.entities.company[linkable.provider_id];
            const activity = linkerContext.entities.activity[linkable.activity_id];
            const balance = parseBig(linkable.balance);
            return (
              <tr key={id} className={idx % 2 === 0 ? undefined : oddRow}>
                <td className={tableCell}>
                  <div className={popoverText}>{product && <ProductTitle product={product} />}</div>
                </td>
                <td className={tableCell}>
                  <div className={popoverText}>
                    <TitleContainer title={provider?.internal_name || '—'} subtitle={activity?.name || '—'} />
                  </div>
                </td>
                <td className={numberCell}>
                  <div className={popoverTextBold}>{fmt(balance)}</div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
}
